import { get } from './get'
import { handleProducts } from './handleProducts'
import { list } from './list'

export default {
  ...list,
  ...get,
  ...handleProducts
}
